import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { usePageTitle } from '../hooks/usePageTitle';
import DocumentUploadStep from '../components/CustomerFlow/Steps/DocumentUploadStep';

const MobileOnboardingPage = () => {
  const { token } = useParams();
  
  // Establecer el título de la página
  usePageTitle('Documentos de Venta');

  // Obtener datos del token desde localStorage (ya validados por MobileProtectedRoute)
  const tokenScope = useMemo(() => {
    const storedScope = localStorage.getItem('temp_tokenScope');
    return storedScope ? JSON.parse(storedScope) : {};
  }, []);

  // Manejo de completación de documentos
  const handleDocumentsComplete = (data) => {
    Swal.fire({
      title: '¡Documentos Completados!',
      html: `
        <p>Has completado la carga de documentos exitosamente.</p>
        <small class="text-muted">Puedes cerrar esta ventana o continuar cargando documentos opcionales si los hay.</small>
      `,
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Cerrar',
      cancelButtonText: 'Continuar',
    }).then((result) => {
      if (result.isConfirmed) {
        window.close(); // Intenta cerrar la pestaña
      }
      // Si cancela, simplemente continúa en la página
    });
  };

  return (
    <div className="container-fluid min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-8">
          <div className="card shadow-sm border-0 mt-3">
            <div className="card-body p-0">
              <DocumentUploadStep
                standalone={true}
                tokenScope={tokenScope}
                onComplete={handleDocumentsComplete}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileOnboardingPage; 